<template>
    <div class="pages selectCoupon">
        <el-dialog
        title="选择优惠券"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleClose">
            <div class="dialogContent">
                <div class="d1">
                    <div>
                        <p>
                            关键词：
                            <el-input
                                placeholder="请输入优惠券名称搜索"
                                suffix-icon="el-icon-search"
                                v-model="input1">
                            </el-input>
                        </p>
                        <p>
                            类型：
                            <el-select v-model="value" placeholder="请选择优惠券类型">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </p>
                    </div>
                    <p class=" dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="dialogVisible = false">确定选中</el-button>
                    </p>
                </div>
                <el-table
                :data="tableData"
                :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                :cell-style="{textAlign:'center',fontSize:'12px'}"
                style="width: 100%">
                     <el-table-column
                    type="selection"
                    width="55">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="优惠券名称"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="number"
                         show-overflow-tooltip
                        label="类型"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="xmember"
                        label="业务系统"
                       
                        >
                    </el-table-column>
                    <el-table-column
                        prop="lmember"
                        label="内容"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="lmember2"
                        label="状态"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="lmember3"
                        label="已领取"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="lmember3"
                        label="剩余"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="lmember3"
                        label="已使用"
                        >
                    </el-table-column>
                </el-table>
                 <div class="page pageL">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="margin-top: 24px;"
                    :current-page="query.page_index"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.page_size"
                    layout="prev, pager, next, sizes, jumper"
                    :total="total"
                    ></el-pagination>
                </div>
            </div>
            <!-- <span slot="footer" class=" dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>
<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
export default {
    data() {
        return {
            query:JSON.parse(JSON.stringify(QUERY)),
               total:100,
            dialogVisible: false,
            options: [{
                value: '选项1',
                label: '小程序1'
                }, {
                value: '选项2',
                label: '小程序2'
            }],
            value:"",
            tableData: [{
                id:1,
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                lmember2:"发送中",
                lmember3:"100",
            },{
                id:1,
                name: '6.1活动券',
                number:"满减券",
                xmember:"业务系统",
                lmember:"满99,减10",
                lmember2:"发送中",
                lmember3:"100",
            },{
                id:1,
                name: '生日活动券',
                number:"双11大额优惠券",
                xmember:"业务系统",
                lmember:"满99,减10",
                lmember2:"发送中",
                lmember3:"100",
            },{
                id:1,
                name: '生日活动券',
                number:"特大聚汇活动",
                xmember:"积分商城",
                lmember:"满99,减10",
                lmember2:"发送中",
                lmember3:"100",
            },{
                id:1,
                name: '生日活动券',
                number:"双12活动券",
                xmember:"积分商城",
                lmember:"满99,减10",
                lmember2:"发送中",
                lmember3:"100",
            },{
                id:1,
                name: '生日活动券',
                number:"十月一活动券",
                xmember:"积分商城",
                lmember:"满99,减10",
                lmember2:"发送中",
                lmember3:"100",
            },], 
        }
    },
    methods:{
        show(){
            this.dialogVisible=true;
        }
    }
}
</script>
<style lang="less" scoped>
    .selectCoupon{
        .d1{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding:30px 30px;
            div{
                display: flex;
                align-items: center;
                p{
                    margin-right:15px;
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    font-weight: 400;
                    color: #676D73;
                }
            }
            /deep/ .el-button {
                border-radius: 30px;
            }
            /deep/ .el-input{
                width:200px;
            }
        }
        /deep/ .el-checkbox__inner{
            border-radius: 50%;
        }
        .page{
            padding:0 30px;
            padding-bottom:30px;
        }
    }
</style>